import CloseMultipleTabsChannel from 'actions/multiple_tabs/close_multiple_tabs_channel';
import FlushUnsavedCompositions from 'actions/composition/flush_unsaved_compositions';
import { flushAllAgentReadUpdates } from 'actions/conversation/update_agent_read';
import StopCustomerViewing from 'actions/customer_viewers/stop_customer_viewing';

export default function configureWindowUnloadHandlers(context) {
  window.addEventListener('beforeunload', evt => {
    context.executeAction(FlushUnsavedCompositions, evt);
    context.executeAction(CloseMultipleTabsChannel);
  });

  // Agent read updates are throttled, so send any pending ones before the page goes away or into the background.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      flushAllAgentReadUpdates();
    }
  });

  // Announcing that we've left a customer page belongs on `pagehide`, not
  // `beforeunload`: FlushUnsavedCompositions can cancel the unload to warn about
  // unsaved work, and on `beforeunload` we'd have already told everyone this agent
  // was gone while they're in fact still sitting there. `pagehide` only fires once
  // the page is really going away.
  window.addEventListener('pagehide', () => {
    flushAllAgentReadUpdates();

    const currentLocation = context.stores.currentLocation.get();
    const customerId = currentLocation && currentLocation.customerId;
    if (!customerId) {
      return;
    }

    context.executeAction(StopCustomerViewing, { customerId });
  });
}
